export const TYPE_NEW_POSTS = 'new-posts';
export const TYPE_RELATED_POSTS = 'related-posts';
